import React, { useEffect, useState } from "react";
import smallMagnifyingGlass from "../../../../assets/images/Common/smallMagnifyingGlass.png";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import classes from "./LangChangePopUp.module.scss";
import setAndGetLocalLang from "../../../../utils/setAndGetLocalLang";
import { languages } from "../../../../utils/languages";

const LangChangePopUp = ({
  reference,
  handleLanguagePopUp,
  top = "6.05",
  right = "-5",
}) => {
  const dispatch = useDispatch();
  const [lang, setLang] = useState(languages);
  const [selectedLang, setSelectedLang] = useState(null);

  useEffect(() => {
    if (selectedLang === null) {
      languages?.forEach((language) => {
        if (language.Value.includes(localStorage.getItem("language"))) {
          setSelectedLang(language);
        }
      });
    }
  }, [selectedLang]);

  const handleChange = (e) => {
    const value = e.target.value;
    const filteredLangArray = languages?.filter((lang) => {
      if (lang.Value.toLowerCase().includes(value.toLowerCase())) {
        return lang;
      } else {
        return "";
      }
    });
    if (value.length > 0) {
      setLang(filteredLangArray);
    } else {
      setLang(languages);
    }
  };

  const handleClick = (lang) => {
    setSelectedLang(lang);
  };

  const handleSubmit = (lang) => {
    setAndGetLocalLang(lang.Locale, lang.Value, dispatch);
    handleLanguagePopUp();
  };

  return (
    <div
      ref={reference}
      className={classes.homeHeaderLanguage}
      style={{ top: top + "rem", right: right + "rem" }}
    >
      {/* <div className={classes.homeHeaderLanguage__heading}>
        <FormattedMessage id="credits.global" />{" "}
        <FormattedMessage id="account.language" />{" "}
      </div> */}
      <div className={classes.homeHeaderLanguage__searchBox}>
        <img
          className={classes.homeHeaderLanguage__searchBox__image}
          src={smallMagnifyingGlass}
          alt="language search box"
        />
        <input
          className={classes.homeHeaderLanguage__searchBox__inputField}
          type="text"
          placeholder="Search Language"
          onChange={handleChange}
        />
      </div>
      <ul className={classes.homeHeaderLanguage__list}>
        {lang?.map((language) => {
          if (
            language?.Value !== "Elliniká" &&
            language?.Value !== "Polski" &&
            language?.Value !== "Português-Brasil" &&
            language?.Value !== "Italiano" &&
            language?.Value !== "Nederlands" &&
            language?.Value !== "Româna"
          ) {
            return (
              <li
                key={language?.Id}
                onClick={() => handleClick(language)}
                className={classes.homeHeaderLanguage__list__item}
              >
                <input
                  type="radio"
                  onChange={() => handleClick(language)}
                  checked={selectedLang?.Locale === language?.Locale}
                  className={classes.homeHeaderLanguage__list__check}
                  style={{
                    width: "1.9rem",
                    height: "1.9rem",
                    cursor: "pointer",
                  }}
                />
                <p className={classes.homeHeaderLanguage__list__language}>
                  {language?.Value}
                </p>
              </li>
            );
          }
          return <></>;
        })}
      </ul>
      <div className={classes.homeHeaderLanguage__buttonArea}>
        <button
          className={classes.homeHeaderLanguage__button}
          onClick={() => handleSubmit(selectedLang)}
        >
          <FormattedMessage id="APPLY" />
        </button>
      </div>
    </div>
  );
};

export default LangChangePopUp;
